import { ValidateSqlInjection } from './../Security'

import { GetAllDataGroups as DLGetAllDataGroups, GetZtudentsOfGroup as DLGetZtudentsOfGroup, GetZtudentGroups as DLGetZtudentGroups, CreateGroup as DLCreateGroup, DeleteGroup as DLDeleteGroup, AcceptZtudent as DLAcceptZtudent, RejectZtudent as DLRejectZtudent, DeleteZtudentOfGroup as DLDeleteZtudentOfGroup, HideZtudent as DLHideZtudent, ShowZtudent as DLShowZtudent, ShowGroup as DLShowGroup, HideGroup as DLHideGroup, ArchiveGroups as DLArchiveGroups, UnarchiveGroups as DLUnarchiveGroups, RenameGroup as DLRenameGroup } from './../../DL/Instructor/Groups'
import { LogErrors } from './../../LogErrors'
import { UpdateSessionInfo } from '../Sessions'


//--- Groups ---//

const GetAllDataGroups = async () => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
          return { success: false, message: '' }
        }

        const idRole = userData?.navigation?.role?.id
        if (!idRole) {
          return { success: false, message: '' }
        }

        const token = userData?.token
        if (!token) {
          return { success: false, message: '' }
        }
        
        const response = await DLGetAllDataGroups(idCenter, idRole, token)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetAllDataGroups - BL Groups', error)
        return { success: false, message: 'No ha sido posible obtener el listado de grupos. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

const GetZtudentGroups = async (ztudent) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
            return { success: false, message: '' }
        }

        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const response = await DLGetZtudentGroups(ztudent.idZtudiante, idCenter, token)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetZtudentGroups - BL Groups', error)
        return { success: false, message: 'No ha sido posible obtener los estudiantes de los grupos. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

const DeleteGroup = async (group, rows) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const response = await DLDeleteGroup(group.id, token)
        
        if (response.success) {
            // Eliminar fila
            const updatedRows = rows.filter(z => z.id !== group.id)

            return { success: true, data: updatedRows }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        //console.error('Error en DeleteGroup:', error)
        await LogErrors('DeleteGroup - BL Groups', error)
        return { success: false, message: 'No ha sido posible eliminar el grupo. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

const ShowGroup = async (group, visibleRowsList, hiddenRowsList) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const response = await DLShowGroup(group.id, token)
        
        if (response.success) {
            // 1. Asegurarse de eliminar correctamente el grupo de la lista de ocultos
            const updatedHidden = hiddenRowsList.filter(z => z.id !== group.id)

            // 2. Eliminar el grupo de visibles si por error ya estaba
            const visibleWithoutGroup = visibleRowsList.filter(z => z.id !== group.id)

            // 3. Agregarlo actualizado con `visible: true`
            const updatedVisible = [...visibleWithoutGroup, { ...group, visible: true }]
            
            return { success: true, data: { updatedVisible, updatedHidden } }   
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        //console.error('Error en ShowGroup:', error)
        await LogErrors('ShowGroup - BL Groups', error)
        return { success: false, message: 'No ha sido posible mostrar el grupo. Inténtalo nuevamente más tarde' }
    }
}

const HideGroup = async (group, visibleRowsList, hiddenRowsList) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const response = await DLHideGroup(group.id, token)
        
        if (response.success) {
            // 1. Eliminar de visibles (por si estaba)
            const updatedVisible = visibleRowsList.filter(z => z.id !== group.id)

            // 2. Eliminar de ocultos (por si estaba)
            const hiddenWithoutGroup = hiddenRowsList.filter(z => z.id !== group.id)

            // 3. Agregar con visible: false
            const updatedHidden = [...hiddenWithoutGroup, { ...group, visible: false }]
            
            return { success: true, data: { updatedVisible, updatedHidden } }   
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        //console.error('Error en HideGroup:', error)
        await LogErrors('HideGroup - BL Groups', error)
        return { success: false, message: 'No ha sido posible ocultar el grupo. Inténtalo nuevamente más tarde', }
    }
}

/**
 * Archiva un grupo. El endpoint responde con un resultado por grupo (results[]), así que
 * se valida el "outcome" de este grupo específico antes de reconstruir las listas locales,
 * para no dar un falso éxito si el backend lo rechazó individualmente.
 */
const ArchiveGroup = async (group, visibleRowsList, hiddenRowsList) => {
    try {
        // Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } // En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }

        // Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))

        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }

        const response = await DLArchiveGroups([group.id], token)

        if (!response.success) {
            return { success: false, message: response.message }
        }

        const result = response.data?.results?.find(r => r.idGroup === group.id)
        if (!result || result.outcome !== 'Archived') {
            return { success: false, message: result?.errorMessage || 'No fue posible archivar el grupo.' }
        }

        // 1. Eliminar de visibles (por si estaba)
        const updatedVisible = visibleRowsList.filter(z => z.id !== group.id)

        // 2. Eliminar de ocultos (por si por error ya estaba)
        const hiddenWithoutGroup = hiddenRowsList.filter(z => z.id !== group.id)

        // 3. Agregarlo actualizado con visible: false
        const updatedHidden = [...hiddenWithoutGroup, { ...group, visible: false }]

        return { success: true, data: { updatedVisible, updatedHidden } }
    } catch (error) {
        await LogErrors('ArchiveGroup - BL Groups', error)
        return { success: false, message: 'No ha sido posible archivar el grupo. Inténtalo nuevamente más tarde' }
    }
}

/**
 * Desarchiva un grupo. El endpoint responde con un resultado por grupo (results[]),
 * así que se valida el "outcome" de este grupo específico antes de reconstruir las
 * listas locales, para no dar un falso éxito si el backend lo rechazó individualmente.
 */
const UnarchiveGroup = async (group, visibleRowsList, hiddenRowsList) => {
    try {
        // Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } // En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }

        // Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))

        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }

        const response = await DLUnarchiveGroups([group.id], token)

        if (!response.success) {
            return { success: false, message: response.message }
        }

        const result = response.data?.results?.find(r => r.idGroup === group.id)
        if (!result || result.outcome !== 'Unarchived') {
            return { success: false, message: result?.errorMessage || 'No fue posible desarchivar el grupo.' }
        }

        // 1. Eliminar de ocultos (por si estaba)
        const updatedHidden = hiddenRowsList.filter(z => z.id !== group.id)

        // 2. Eliminar de visibles (por si por error ya estaba)
        const visibleWithoutGroup = visibleRowsList.filter(z => z.id !== group.id)

        // 3. Agregarlo actualizado con visible: true
        const updatedVisible = [...visibleWithoutGroup, { ...group, visible: true }]

        return { success: true, data: { updatedVisible, updatedHidden } }
    } catch (error) {
        await LogErrors('UnarchiveGroup - BL Groups', error)
        return { success: false, message: 'No ha sido posible desarchivar el grupo. Inténtalo nuevamente más tarde' }
    }
}

//--- Groups ---//



//--- Group ---//

const GetCurrentGroup = async () => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))

        const group = userData?.navigation?.group
        if (group) {
            return { success: true, data: group }
        } else {
            return { success: false, message: 'No ha sido posible obtener la información del grupo. Intenta actualizar la página o inténtalo más tarde' }
        }
    } catch (error) {
        await LogErrors('GetCurrentGroup - BL Groups', error)
        return { success: false, message: 'No ha sido posible obtener la información del grupo. Intenta actualizar la página o inténtalo más tarde' }
    }
}

const GetZtudentsOfGroup = async (group) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))

        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const response = await DLGetZtudentsOfGroup(group.id, token)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetZtudentsOfGroup - BL Groups', error)
        return { success: false, message: '' }
    }
}

const AcceptZtudent = async (ztudent, rows) => {
    try {
        if (ztudent.isAccepted) {
            return { success: false, message: 'El Ztudiante ya está aceptado' }
        }


        // Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        // Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const idGroup = userData?.navigation?.group?.id
        if (!idGroup) {
            return { success: false, message: '' }
        }

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
            return { success: false, message: '' }
        }
        
        const response = await DLAcceptZtudent(ztudent.idZtudiante, idGroup, idCenter, token)
        
        if (response.success) {
            // Marcar Ztudiante como aceptado
            const updatedRows = rows.map(z =>
                z.idZtudiante === ztudent.idZtudiante ? { ...z, isAccepted: true } : z
            )
            
            return { success: true, data: updatedRows }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        //console.error('Error en AcceptZtudent:', error)
        await LogErrors('AcceptZtudent - BL Groups', error)
        return { success: false, message: 'No ha sido posible aceptar al Ztudiante. Inténtalo nuevamente o más tarde', }
    }
}

const RejectZtudent = async (ztudent, rows) => {
    try {
        if (ztudent.isAccepted) {
            return { success: false, message: 'No es posible rechazar al Ztudiante. Ya fue aceptado anteriormente' }
        }

        
        // Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        // Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const idGroup = userData?.navigation?.group?.id
        if (!idGroup) {
            return { success: false, message: '' }
        }

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
            return { success: false, message: '' }
        }
        
        const response = await DLRejectZtudent(ztudent.idZtudiante, idGroup, idCenter, token)
        
        if (response.success) {
            // Quitar Ztudiante de listado
            const updatedRows = rows.filter(z => z.idZtudiante !== ztudent.idZtudiante)
            
            return { success: true, data: updatedRows }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        //console.error('Error en RejectZtudent:', error)
        await LogErrors('RejectZtudent - BL Groups', error)
        return { success: false, message: 'No ha sido posible rechazar al Ztudiante. Inténtalo nuevamente o más tarde' }
    }
}

const DeleteZtudentOfGroup = async (ztudent, rows) => {
    try {
        if (!ztudent.isAccepted) {
            return { success: false, message: 'Solo se pueden eliminar Ztudiantes que ya han sido aceptados' }
        }


        // Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        // Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const idGroup = userData?.navigation?.group?.id
        if (!idGroup) {
            return { success: false, message: '' }
        }
        
        const response = await DLDeleteZtudentOfGroup(ztudent.idZtudiante, idGroup, token)
        
        if (response.success) {
            // Quitar Ztudiante de listado
            const updatedRows = rows.filter(z => z.idZtudiante !== ztudent.idZtudiante)
            
            return { success: true, data: updatedRows }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        //console.error('Error en DeleteZtudentOfGroup:', error)
        await LogErrors('DeleteZtudentOfGroup - BL Groups', error)
        return { success: false, message: 'No ha sido posible quitar al Ztudiante del grupo. Inténtalo nuevamente o inténtelo más tarde.' }
    }
}

const HideZtudent = async (ztudent, rows) => {
    try {
        if (!ztudent.isAccepted) {
            return { success: false, message: 'No se puede ocultar el Ztudiante ya que aún no ha sido aceptado.' }
        }

        if (!ztudent.isVisible) {
            return { success: false, message: 'No se puede ocultar al Ztudiante. Ya está oculto.' }
        }


        // Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        // Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const idGroup = userData?.navigation?.group?.id
        if (!idGroup) {
            return { success: false, message: '' }
        }
        
        const response = await DLHideZtudent(ztudent.idZtudiante, idGroup, token)
        
        if (response.success) {
            // Quitar Ztudiante de listado de visibles
            const updatedVisible = rows.filter(z => z.idZtudiante !== ztudent.idZtudiante)
            
            // Obtener info de Ztudiante y marcarlo como oculto
            const updatedHidden = rows.filter(z => z.isVisible === false)
            const tmpZtudent = rows.find(z => z.idZtudiante === ztudent.idZtudiante)
            tmpZtudent.isVisible = false
            
            // Agregar Ztudiante a listado de ocultos
            updatedHidden.push(tmpZtudent)
            
            return { success: true, data: { updatedVisible, updatedHidden } }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        //console.error('Error en HideZtudent:', error)
        await LogErrors('HideZtudent - BL Groups', error)
        return { success: false, message: 'No ha sido posible ocultar al Ztudiante. Inténtalo nuevamente o más tarde.' }
    }
}

const ShowZtudent = async (ztudent, rows, allRows) => {
    try {
        if (!ztudent.isAccepted) {
            return { success: false, message: 'No se puede mostrar el ztudiante ya aún no ha sido aceptado.' }
        }
        
        if (ztudent.isVisible) {
            return { success: false, message: 'No se puede mostrar al ztudiante. Ya se está mostrando actualmente.' }
        }
        

        // Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        // Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        const idGroup = userData?.navigation?.group?.id
        if (!idGroup) {
            return { success: false, message: '' }
        }
        
        const response = await DLShowZtudent(ztudent.idZtudiante, idGroup, token)
        
        if (response.success) {
            // Obtener info de Ztudiante y marcarlo como visible
            const updatedVisible = allRows.filter(z => z.isVisible === true)
            const tmpZtudent = allRows.find(z => z.idZtudiante === ztudent.idZtudiante)
            tmpZtudent.isVisible = true

            // Agregar Ztudiante a listado de visibles
            updatedVisible.push(tmpZtudent)
            
            // Quitar Ztudiante de listado de ocultos
            const updatedHidden = rows.filter(z => z.idZtudiante !== ztudent.idZtudiante)
            
            return { success: true, data: { updatedVisible, updatedHidden } }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        //console.error('Error en ShowZtudent:', error)
        await LogErrors('ShowZtudent - BL Groups', error)
        return { success: false, message: 'No ha sido posible mostrar al Ztudiante. Inténtalo nuevamente o más tarde.' }
    }
}

//--- Group ---//



//--- Groups Create ---//

const CreateGroup = async (groupName) => {
    try {
        if (groupName) {
            const name = groupName.trim()

            if (name === '') {
                return {success: false, message: `Escribe el nombre del grupo`}
            }

            // Validación de la info del cuadro de texto
            const regex = /^[a-záéíóúüñ0-9 ]+$/
            //const regex = /^[a-z0-9]+$/

            if (!regex.test(name.toLowerCase())) {
                return { success: false, message: 'El nombre del grupo contiene caracteres no permitidos.' }
            } else if (await ValidateSqlInjection(name)) {
                return { success: false, message: 'El nombre del grupo que escribiste no es válido.' }
            }



            //Validar que exista la info del usuario en el session storage
            if (!sessionStorage.getItem('userData')) {
                return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
            }
        
            //Obtener la info del usuario desde el session storage
            const userData = JSON.parse(sessionStorage.getItem('userData'))

            const idCenter = userData?.navigation?.center?.id
            if (!idCenter) {
                return { success: false, message: '' }
            }

            const idRole = userData?.navigation?.role?.id
            if (!idRole) {
                return { success: false, message: '' }
            }

            const token = userData?.token
            if (!token) {
                return { success: false, message: '' }
            }
            
            const response = await DLCreateGroup(name, idCenter, idRole, token)
            
            if (response.success) {
                return { success: true, data: response.data }
            } else {
                return { success: false, message: response.message }
            }
        } else {
            return {
                success: false,
                message: `Escribe el nombre del grupo`
            }
        }
    } catch (error) {
        //console.error('Error en CreateGroup:', error)
        await LogErrors('CreateGroup - BL Groups', error)
        return { success: false, message: 'No ha sido posible crear el grupo. Inténtalo nuevamente o inténtelo más tarde.', }
    }
}

//--- Groups Create ---//


//--- Groups Common ---//

const RenameGroup = async (idGroup, newGroupName) => {
    try {
        // Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        // Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }
        
        if (!idGroup) {
            return { success: false, message: '' }
        }

        if (!newGroupName || newGroupName === '') {
            return { success: false, message: '' }
        }

        const name = newGroupName.trim()

        // Validación de la info del cuadro de texto (misma regla que CreateGroup)
        const regex = /^[a-záéíóúüñ0-9 ]+$/

        if (!regex.test(name.toLowerCase())) {
            return { success: false, message: 'El nombre del grupo contiene caracteres no permitidos.' }
        } else if (await ValidateSqlInjection(name)) {
            return { success: false, message: 'El nombre del grupo que escribiste no es válido.' }
        }

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
            return { success: false, message: '' }
        }
        
        const response = await DLRenameGroup(idGroup, newGroupName, idCenter, 2, token)
        
        if (response.success) {
            // Checar si existe el grupo en el sessionStorage
            const groupName = userData?.navigation?.group?.name

            if (groupName) {
                // Actualizar nombre del grupo del sessionStorage
                userData.navigation.group.name = newGroupName
                
                await UpdateSessionInfo(userData)
            }

            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        //console.error('Error en RenameGroup:', error)
        await LogErrors('RenameGroup - BL Groups', error)
        return { success: false, message: 'No ha sido posible renombrar el grupo. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

//--- Groups Common ---//

export { GetAllDataGroups, GetCurrentGroup, GetZtudentsOfGroup, GetZtudentGroups, DeleteGroup, HideGroup, ArchiveGroup, UnarchiveGroup, AcceptZtudent, RejectZtudent, DeleteZtudentOfGroup, HideZtudent, ShowZtudent, CreateGroup, ShowGroup, RenameGroup };